import { render, staticRenderFns } from "./ConfigFile.vue?vue&type=template&id=49dc792c&"
import script from "./ConfigFile.vue?vue&type=script&lang=js&"
export * from "./ConfigFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports